/* TE · Fiche produit mobile : place les blocs de snippets/te-pdp-mobile-blocs.liquid à leur rang (maquette validée). Sous 768 px uniquement. */
(function () {
  if (!window.matchMedia) return;
  var mq = window.matchMedia('(max-width: 767px)');
  var done = false;
  /* Repasse en desktop : les blocs placés se cachent, le rendu desktop reste celui du thème. */
  function onMedia() {
    if (!mq.matches) {
      document.documentElement.classList.remove('te-pdp-blocs-on');
      document.documentElement.classList.remove('te-pdp-score-on');
      document.querySelectorAll('#MainContent > [data-te-bloc], .te-pdp-avis').forEach(function (el) { el.hidden = true; });
      drawers(false);
      return;
    }
    if (!done) { done = true; init(); return; }
    if (document.querySelector('#MainContent > [data-te-bloc]')) document.documentElement.classList.add('te-pdp-blocs-on');
    if (document.querySelector('.te-pdp-score')) document.documentElement.classList.add('te-pdp-score-on');
    document.querySelectorAll('#MainContent > [data-te-bloc]').forEach(function (el) { el.hidden = false; });
    drawers(true);
    document.querySelectorAll('.te-pdp-avis[data-te-avis-filled]').forEach(function (el) { el.hidden = false; });
  }
  if (mq.addEventListener) mq.addEventListener('change', onMedia); else if (mq.addListener) mq.addListener(onMedia);
  if (mq.matches) { done = true; init(); }

  /* L'atelier remplace la section Détails en mobile. */
  function drawers(hide) {
    var d = document.querySelector('#MainContent > [id$="__te_drawers"]');
    if (d && document.querySelector('#MainContent > [data-te-bloc="atelier"]')) d.hidden = hide;
  }

  function init() {
  var main = document.getElementById('MainContent');
  var box = document.querySelector('.te-pdp-blocs');
  if (!main || !box) return;

  var ranks = { pourquoi: 3, specs: 4, comparateur: 5, atelier: 6, infos: 7 };
  var moved = 0;
  box.querySelectorAll('[data-te-bloc]').forEach(function (el) {
    var rank = ranks[el.getAttribute('data-te-bloc')];
    if (!rank) return;
    el.style.order = rank;
    main.appendChild(el);
    moved++;
  });
  if (!moved) return;
  document.documentElement.classList.add('te-pdp-blocs-on');
  drawers(true);

  /* Photo du bloc « pourquoi » : celle de la section matières */
  var photoSlot = main.querySelector('[data-te-photo]');
  var photo = document.querySelector('.te-materials-photo img');
  if (photoSlot && photo) {
    var img = photo.cloneNode(false);
    img.removeAttribute('class');
    img.setAttribute('loading', 'lazy');
    photoSlot.appendChild(img);
  } else if (photoSlot) {
    photoSlot.remove();
  }

  /* Livraison et retours : texte du dépliant du thème */
  var livraison = main.querySelector('[data-te-livraison]');
  document.querySelectorAll('.product__accordion').forEach(function (acc) {
    var title = acc.querySelector('.product__accordion__title');
    if (!livraison || !title || title.textContent.trim().indexOf('Livraison') !== 0) return;
    var body = document.getElementById(title.getAttribute('aria-controls')) || title.nextElementSibling;
    if (body && body.textContent.trim()) {
      var copy = body.cloneNode(true);
      copy.removeAttribute('id');
      copy.removeAttribute('hidden');
      copy.removeAttribute('style');
      copy.className = '';
      livraison.innerHTML = '';
      livraison.appendChild(copy);
    }
  });

  /* Bloc avis : note en grand sous le titre, comme la maquette (note et volume lus dans la section) */
  var scoreTries = 0;
  function score() {
  var vs = document.querySelector('.te-voices');
  var sum = vs && vs.querySelector('.te-voices__summary');
  var mt = sum && sum.textContent.match(/([\d.,]+)\s*\/\s*5\D+(\d+)\s+avis/);
  var head = vs && vs.querySelector('.te-voices__head');
  if (!mt || !head) { if (++scoreTries < 16) setTimeout(score, 500); return; }
  if (!vs.querySelector('.te-pdp-score')) {
    var note = Math.round(parseFloat(mt[1].replace(',', '.')) * 10) / 10;
    var sc = document.createElement('div');
    sc.className = 'te-pdp-score';
    var big = document.createElement('p');
    big.className = 'te-pdp-score__note';
    big.textContent = String(note).replace('.', ',');
    var side = document.createElement('div');
    var stars = document.createElement('span');
    stars.className = 'te-pdp-score__stars';
    stars.setAttribute('role', 'img');
    stars.setAttribute('aria-label', 'Note moyenne ' + big.textContent + ' sur 5');
    stars.textContent = '★★★★★';
    var cnt = document.createElement('p');
    cnt.className = 'te-pdp-score__count';
    cnt.textContent = mt[2] + ' avis boutique';
    side.appendChild(stars); side.appendChild(cnt);
    sc.appendChild(big); sc.appendChild(side);
    head.appendChild(sc);
    if (mq.matches) document.documentElement.classList.add('te-pdp-score-on');
  }
  }
  score();

  /* Résumé des avis sous l'achat : deux avis boutique réels, courts */
  var avis = box.querySelector('[data-te-avis]');
  var service = Array.prototype.filter.call(document.querySelectorAll('[id$="__main"] te-product-service'), function (el) { return el.getClientRects().length; })[0];
  var voices = document.querySelector('.te-voices');
  if (!avis || !service || !voices) return;
  var voicesSection = voices.closest('.shopify-section');
  if (voicesSection && voicesSection.id) avis.querySelector('[data-te-avis-lien]').setAttribute('href', '#' + voicesSection.id);
  var tries = 0;
  function fill() {
    var cards = voices.querySelectorAll('.te-voices__card');
    var picked = [];
    cards.forEach(function (card) {
      if (picked.length === 2) return;
      var q = card.querySelector('.te-voices__quote');
      var by = card.querySelector('.te-voices__byline');
      var prod = card.querySelector('.te-voices__product');
      var st = card.querySelector('.te-voices__stars');
      if (!q || !st) return;
      var text = q.textContent.trim();
      if (text.length < 20 || text.length > 140) return;
      /* Pas de mise en avant d'un avis à réserve (« trop chaud », « mais », « déçu »…) */
      if (/\b(trop|mais|déçu|déçue|dommage|bof|moyen|juste|pas encore|à peine)\b/i.test(text)) return;
      if (st.textContent.replace(/[^★]/g, '').length < 5) return;
      picked.push({ st: st.textContent.trim(), stl: st.getAttribute('aria-label') || '', q: text, by: by ? by.textContent.trim() : '', prod: prod && prod.querySelector('.te-voices__product-title') ? prod.querySelector('.te-voices__product-title').textContent.trim() : '' });
    });
    if (picked.length < 2) {
      if (++tries < 12) setTimeout(fill, 500);
      return;
    }
    var list = avis.querySelector('[data-te-avis-list]');
    picked.forEach(function (p) {
      var a = document.createElement('article');
      var s = document.createElement('span');
      s.className = 'te-pdp-avis__stars';
      s.setAttribute('role', 'img');
      s.setAttribute('aria-label', p.stl);
      s.textContent = p.st;
      var t = document.createElement('p');
      t.textContent = p.q;
      var b = document.createElement('p');
      b.className = 'te-pdp-avis__by';
      b.textContent = p.by + (p.prod ? ', ' + p.prod : '');
      a.appendChild(s); a.appendChild(t); a.appendChild(b);
      list.appendChild(a);
    });
    var summary = voices.querySelector('.te-voices__summary');
    var link = avis.querySelector('[data-te-avis-lien]');
    var n = summary && summary.textContent.match(/(\d+)\s+avis/);
    if (n) link.textContent = 'Les ' + n[1] + ' avis';
    service.insertAdjacentElement('afterend', avis);
    avis.setAttribute('data-te-avis-filled', '');
    avis.hidden = !mq.matches;
  }
  setTimeout(fill, 0);
  }
})();
